export default __webpack_public_path__ + "static/media/rm3.a170404f.png";